import axios from 'axios';

export const setupTwoFactorAuthentication = async values =>
  axios.put(`/profile/user/setup-two-factor`, { ...values });

export const enableTwoFactorAuthentication = async values =>
  axios.put(`/profile/user/enable-two-factor`, { ...values });

export const disableTwoFactorAuthentication = async values =>
  axios.put(`/profile/user/disable-two-factor`, { ...values });

export default { setupTwoFactorAuthentication, enableTwoFactorAuthentication, disableTwoFactorAuthentication };
